import React from "react";
import { CostingHistoryEntry } from "../../interfaces/app_types";
import { formatTimestamp } from "../../utils/funcs/days";

interface HistoryBarProps {
  history: CostingHistoryEntry[];
  activeHistoryId: string | null;
  onEntryClick: (entry: CostingHistoryEntry) => void;
}

const HistoryBarCosting: React.FC<HistoryBarProps> = ({
  history,
  activeHistoryId,
  onEntryClick,
}) => {
  if (history.length === 0) return null;

  return (
    <div className="costing-history-bar">
      <span className="costing-history-bar__label">Recent:</span>
      {history.map((entry) => (
        <button
          key={entry.id}
          className={`costing-history-tab${
            activeHistoryId === entry.id ? " costing-history-tab--active" : ""
          }`}
          onClick={() => onEntryClick(entry)}
          title={`${entry.title} — ${formatTimestamp(entry.timestamp)}`}
        >
          <span className="costing-history-tab__title">{entry.title}</span>
          <span className="costing-history-tab__date">
            {formatTimestamp(entry.timestamp)}
          </span>
          {activeHistoryId === entry.id && (
            <span className="costing-history-tab__close">✕</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default HistoryBarCosting;
